// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-slider__button[data-v-79099353] {\n  background-color: #2468f2;\n  border: 1px solid #2468f2;\n}\n.el-slider__button-wrapper[data-v-79099353] {\n  height: 32px;\n}\n", ""]);
// Exports
module.exports = exports;
